import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDoubleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 31,
	viewBox: "0 0 31 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.7917 9.04163L23.25 15.5L16.7917 21.9583",
		stroke: "black",
		strokeWidth: 2.58333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.75004 9.04163L14.2084 15.5L7.75004 21.9583",
		stroke: "black",
		strokeWidth: 2.58333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgChevronDoubleRight;
